module.exports = __webpack_public_path__ + "img/free_tree_layout_1.9d638c8c.png";